import { create } from "zustand";

import type { ComposerErrorStore } from "./types";

const EXIT_ANIM_DURATION_MS = 400;
const AUTO_DISMISS_MS = 4000;

let exitTimer: ReturnType<typeof setTimeout> | null = null;
let unmountTimer: ReturnType<typeof setTimeout> | null = null;

const clearTimers = () => {
  if (exitTimer) clearTimeout(exitTimer);
  if (unmountTimer) clearTimeout(unmountTimer);
  exitTimer = null;
  unmountTimer = null;
};

export const useComposerError = create<ComposerErrorStore>(set => ({
  displayError: null,
  isExiting: false,
  showError: error => {
    // Reset any in-flight cycle so a new error restarts the full timeline.
    clearTimers();
    set({ displayError: error, isExiting: false });

    exitTimer = setTimeout(() => {
      set({ isExiting: true });
    }, AUTO_DISMISS_MS - EXIT_ANIM_DURATION_MS);

    unmountTimer = setTimeout(() => {
      set({ displayError: null, isExiting: false });
    }, AUTO_DISMISS_MS);
  },
  reset: () => {
    clearTimers();
    set({ displayError: null, isExiting: false });
  },
}));
